<p-toast />
<div class="order-items-search">
  <h1>Consulta de Pedido por Chave da NF</h1>
  <p class="description">
    Busque os produtos de um pedido informando a chave da nota fiscal (NF).
  </p>

  <div class="search-form">
    <div class="form-b4a">
      <div class="field-group">
        <span class="p-float-label">
          <input
            id="chaveNf"
            type="text"
            pInputText
            [formControl]="chaveNfControl"
            placeholder="Ex: 35200114200166000196550010000001111234567890"
            class="search-input"
            (keydown.enter)="searchOrderItems()"
            maxlength="44"
          />
          <label for="chaveNf">Chave da Nota Fiscal</label>
        </span>

        <div class="field-info">
          <div
            *ngIf="chaveNfControl.invalid && chaveNfControl.touched"
            class="error-messages"
          >
            <small *ngIf="chaveNfControl.errors?.['required']" class="p-error">
              A chave da nota fiscal é obrigatória.
            </small>
            <small
              *ngIf="
                chaveNfControl.errors?.['minlength'] ||
                chaveNfControl.errors?.['maxlength']
              "
              class="p-error"
            >
              A chave da nota fiscal deve ter exatamente 44 dígitos.
            </small>
            <small *ngIf="chaveNfControl.errors?.['pattern']" class="p-error">
              A chave da nota fiscal deve conter apenas números.
            </small>
          </div>
          <div class="char-counter">
            <small
              [class]="
                (chaveNfControl.value?.length || 0) === 44
                  ? 'char-counter-valid'
                  : 'char-counter-invalid'
              "
            >
              {{ chaveNfControl.value?.length || 0 }}/44
            </small>
          </div>
        </div>

        <div class="button-group">
          <p-button
            label="Buscar"
            icon="pi pi-search"
            [disabled]="chaveNfControl.invalid"
            (onClick)="searchOrderItems()"
          />
          <p-button
            label="Limpar"
            icon="pi pi-times"
            severity="secondary"
            (onClick)="clearSearch()"
          />
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="hasSearched" class="results-container">
    <div *ngIf="orderItems.length === 0" class="empty-state">
      <i class="pi pi-search" style="font-size: 3rem; color: #6c757d"></i>
      <h3>Nenhum produto encontrado</h3>
      <p>Não foram encontrados produtos para a chave NF informada.</p>
    </div>

    <div *ngIf="orderItems.length > 0" class="products-grid">
      <div class="results-header">
        <div class="header-left">
          <h2>
            <i class="pi pi-box"></i>
            Quantidade Total de Produtos Encontrados ({{ totalQuantity }})
          </h2>
          <div class="filtered-key-info" *ngIf="filteredChaveNf">
            <span class="key-label">Chave NF filtrada:</span>
            <span class="key-value">{{ filteredChaveNf }}</span>
          </div>
        </div>
        <div class="header-controls">
          <p-button
            [label]="
              isDetailedView
                ? 'Visualização Resumida'
                : 'Visualização Detalhada'
            "
            [icon]="isDetailedView ? 'pi pi-list' : 'pi pi-th-large'"
            severity="secondary"
            (onClick)="toggleView()"
          />
        </div>
      </div>

      <!-- Visualização Resumida (padrão) -->
      <div *ngIf="!isDetailedView" class="products-summary">
        <div class="summary-table">
          <div class="table-header">
            <div class="header-cell image-cell">IMAGEM</div>
            <div class="header-cell name-cell">NOME DO PRODUTO</div>
            <div class="header-cell quantity-cell">QUANTIDADE</div>
            <div class="header-cell sku-cell">SKU</div>
            <div class="header-cell ean-cell">EAN INTERNO</div>
          </div>
          <div>
            <app-product-row
              *ngFor="let item of orderItems"
              [item]="item"
            ></app-product-row>
          </div>
        </div>
      </div>

      <!-- Visualização Detalhada -->
      <div *ngIf="isDetailedView" class="products-list">
        <app-product-card
          *ngFor="let item of orderItems"
          [item]="item"
        ></app-product-card>
      </div>
    </div>
  </div>
</div>
